(function (app) {
  $(document).ready(function () {

    app.CampaignList = function () {

      var _this = this;

      var nameSpace = 'CampaignList',
        getUrl = '/api/post/campaign',
        context = '.page__campaign-list--container',
        dataTable = '.table__campaign-list',
        templates = {
          'campaignRow': app.templates["Post__campaigns____row"]
        },

        defaultPageParams = {
          'pageSize': 20,
          'pageNo': 1,
          'q': '',
          'orderBy': 'dateCreated',
          'orderByOrder': "DESC",
          'group': '',
          'queryVal': 'no-trigger',
          'query': ''
        };

      // To update Table view
      _this.updateList = function (response) {
        // Clean up all existing data in dom
        $('.table__campaign-body', $(context).context).html('');
        $(dataTable).removeClass('loading-state');

        if (app.getUnsavedCampaign()) {
          var row = app.getUnsavedCampaign();
          var campaignRow = _.template(templates.campaignRow);
          var $campaignRow = $(
            campaignRow(
              $.extend(row, {
                'rowClass': 'local-storage',
                'name': _.isEmpty(row.name) ? 'Unsaved Campaign' : row.name,
                'status': 'Unsaved',
                'postScheduled': 0,
                'postsPublished': 0,
                'dateCreated': _.isUndefined(row.dateCreated) ? moment(moment().toDate()) : moment(moment.utc(row.dateCreated.date).toDate()),
              })
            )
          );
          $campaignRow.appendTo($('.table__campaign-body', $(context).context));
        }

        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            var campaignRow = _.template(templates.campaignRow);
            var $campaignRow = $(
              campaignRow(
                $.extend(row, {
                  'rowClass': row.status.replace(/ /g,"_"),
                  'dateCreated': moment(row.dateCreated).format('MM/DD/YYYY @ h:mm a'),
                })
              )
            );
            $campaignRow.appendTo($('.table__campaign-body', $(context).context));
          });
        } else {
          $('.page__no--records').show();
        }
      };

      _this.campaignActions = function () {
        return {
          delete: function (campaignId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/post/campaign/' + campaignId);
            return query.promise();
          },
          mass: function () {
            return {
              delete: function (requestData) {
                requestData = requestData || {};
                var query = $.Deferred();

                var $form = $('form[name="campaign-campaigns__list"]', $(context));
                var appTransport = app.transport();
                var formData = $form.serializeObject();
                requestData.ids = formData.ids;

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;

                appTransport.delete('/api/post/campaign/');
                return query.promise();

              },
            }
          }
        }
      };

      _this.context = function () {
        return context;
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.pageParams = function () {
        var storageNameSpace = nameSpace;
        var key = storageNameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();
            delete defaultPageParams['pageSize'];
            delete defaultPageParams['orderBy'];
            delete defaultPageParams['orderByOrder'];
            delete defaultPageParams['group'];
            delete defaultPageParams['queryVal'];
            delete defaultPageParams['query'];
            delete defaultPageParams['q'];

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.buildUrl = function (options) {
        options = _this.pageParams().get();

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.query) ? queryBuilders.push('query=' + options.query + '&' + $.param(options.queryParams)) : '';

        return getUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.getFilters = function () {
        var options = _this.pageParams().get(), filters = {};
        filters = !_.isEmpty(options.query) ? $.extend({}, {'query': options.query}, options.queryParams) : $.extend({}, {'query': 'no-trigger'});
        filters = !_.isEmpty(options.q) ? $.extend(filters, {'search': options.q}) : filters;
        return filters;
      };

      _this.get = function (options) {
        $(dataTable).addClass('loading-state');
        $('.page__no--records').hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };

      _this.pager = function () {
        return {
          init: function (response) {
            $(dataTable).mdcPager({
              counts: parseInt(response.total),
              pageSize: _this.pageParams().get()['pageSize'],
              currentPage: _this.pageParams().get()['pageNo'],
              callback: function (objpage) {
                var pageParams = {pageNo: objpage.pageno, pageSize: objpage.pagesize};
                _this.pageParams().set(pageParams);
                _this.get();
              }
            });
          }
        }
      };

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': $(dataTable).attr('data-orderBy'),
          'orderByOrder': $(dataTable).attr('data-orderByOrder')
        }, defaultPageParams);
      };

      return {
        init: function () {
          // Set Page Params to default or from storage
          _.isNull(_this.pageParams().get()) ? _this.pageParams().set(_this.getDefaultPageParams()) : null;

          // Set sorting on sales team
          $('.table__campaign-list').mdcSort({
            'orderBy': _this.pageParams().get()['orderBy'],
            'orderByOrder': _this.pageParams().get()['orderByOrder'],
            callback: function (obj) {
              var pageParams = {orderBy: obj.orderBy, orderByOrder: obj.orderByOrder};
              _this.pageParams().set(pageParams);
              _this.get();
            }
          });

          // Search box
          $(context + ' :input[name="q"]').val(_this.pageParams().get()['q']);

          $(document).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="campaign__list--search"]', function (e) {
            e.preventDefault();
            var $submitButton = $(this).find(':input[type=submit]');
            $submitButton.button('loading');

            var pageParams = {
              q: $(this).find(':input[name="q"]').val(),
            };
            _this.pageParams().reset();
            _this.pageParams().set(pageParams);
            var campaigns = _this.get();
            $.when(campaigns).done(function (response) {
              _this.pager().init(response);
              $submitButton.button('reset');
            });
          }).off('click.mass_actions__' + nameSpace).on('click.mass_actions__' + nameSpace, context + ' :input[name="mass_actions"]', function (e) {
            if ($(this).is(':checked')) {
              $(':input[name="ids[]"]').prop('checked', true);
            } else {
              $(':input[name="ids[]"]').prop('checked', false);
            }
          }).off('click.mass_actions__action' + nameSpace).on('click.mass_actions__action' + nameSpace, context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'), message;
            switch (action) {
              case 'mass-delete':
                message = "Are you sure to delete selected campaigns?";

                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Mass Action :: Delete')
                  .set('message', message)
                  .set('onok', function (e, value) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    var massDelete = _this.campaignActions().mass().delete({keywords: value});
                    $.when(massDelete).done(function () {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');

                      var data = _this.get();
                      $.when(data).done(function (response) {
                        _this.pager().init(response);
                        $button.button('reset');
                      });

                    }).fail(function (response) {
                      $('.ajs-button.ajs-ok').button('reset');
                      $button.button('reset');
                    });
                  })
                  .set('oncancel', function (e) {
                    $button.button('reset');
                  })
                  .show();
                break;

            }
          }).off('click.unsaved__campaign' + nameSpace).on('click.unsaved__campaign' + nameSpace, context + ' .btn-unsaved-campaign', function (e) {
            app.redirect('/my-account/app-campaign/new', true);
            setTimeout(function () {
              $('.btn-start-unsaved-campaign').click();
            }, 300);
          })
          ;

          // Get Lead Catalog with params set above
          var campaigns = _this.get();

          $.when(campaigns).done(function (response) {
            _this.pager().init(response);
          });


          $(document).off('click.campaign__list--action').on('click.campaign_list-action', context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              campaignId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              message = "Campaign Name :: " + $dataRow.find('.col__name').html() + '<br/>' + 'Status :: ' + $dataRow.find('.col__status').html() + '<br/>';

            switch (action) {

              case 'trash':
                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Confirm Content Delete')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    if(typeof campaignId != 'undefined' && campaignId != '') {
                      var campaignDelete = _this.campaignActions().delete(campaignId);
                      $.when(campaignDelete).done(function () {

                        alertify.confirm().close();
                        $('.ajs-button.ajs-ok').button('reset');

                        var campaigns = _this.get();

                        $.when(campaigns).done(function (response) {
                          _this.pager().init(response);
                          $button.button('reset');

                        });
                      }).fail(function () {
                        $button.button('reset');
                      });
                    } else {
                      app.removeUnsavedCampaign();
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');

                      var campaigns = _this.get();

                      $.when(campaigns).done(function (response) {
                        _this.pager().init(response);
                        $button.button('reset');

                      });
                    }

                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                break;
            }

          });

        }
      };
    };
  });
})(PreBuilt);

